import { heatmap } from '../domain/analytics/analytics';
import type { ReviewHistoryEntry } from '../types';

export function Heatmap({ history }: { history: ReviewHistoryEntry[] }) {
  const data = heatmap(history, 91);
  const max = Math.max(1, ...data.buckets);
  return (
    <div className="heatmap" aria-label="Lernaktivität der letzten 91 Tage">
      {data.buckets.map((count, index) => {
        const level = count === 0 ? 0 : Math.max(1, Math.ceil((count / max) * 4));
        return <span key={index} className={`heat-cell level-${level}`} title={`${count} Reviews`} />;
      })}
    </div>
  );
}
